import { jsx as _jsx } from "react/jsx-runtime";
import { fontColors } from '@sphereon/ui-components.core';
const SSIFilterIcon = (props) => {
    const { height = 16, width = 18, color = fontColors.dark, style } = props;
    return (_jsx("div", { style: { ...style, width, height, display: 'flex' }, children: _jsx("svg", { width: "18", height: "16", viewBox: "0 0 18 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: _jsx("path", { d: "M16.5 1.5H1.5L7.5 8.33222V13.0556L10.5 14.5V8.33222L16.5 1.5Z", stroke: color, strokeOpacity: "0.8", strokeWidth: "1.29412", strokeLinecap: "round", strokeLinejoin: "round" }) }) }));
};
export default SSIFilterIcon;
